import React from 'react'
import GoogleIcon from '../icon/GoogleIcon'

const PageHeaderActions = ({
  title,
  actions = []
}) => {
  return (
    <div className="show-header show-oc-header d-flex align-items-center justify-content-between">
      <h2 className="mb-0">{title}</h2>

      <div className="d-flex align-items-center gap-2">
        {actions.map((action, index) => (
          <button
            key={action.label || index}
            type="button"
            className={`btn ${action.className}`}
            onClick={action.onClick}
            disabled={action.disabled}
          >
            {action.icon && (
              <GoogleIcon
                name={action.icon}
                size={20}
                filled
                className="mr-2"
              />
            )}
            {action.label}
          </button>
        ))}
      </div>
    </div>
  )
}

export default PageHeaderActions